module.exports = __webpack_public_path__ + "static/media/icon-basketball-white.c41b3025.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-basketball-white.svg
// module id = ./src/assets/images/icon-basketball-white.svg
// module chunks = 6